<!-- 사용안함 : 선택등록양식 리스트 보여주는 페이지인데 관람객명단에 통합됨. -->
<template>
  <v-container fluid>

    <!-- 관람객 정보 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_user" @keydown.esc="dialog_user = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('common_userinfo_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_user = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="visitorItem.IDX" :label="$t('eul_col2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="visitorItem.COM_NAME" :label="$t('eventinvit_label15')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="visitorItem.EVENT_NAME" :label="$t('eventinvit_label16')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field :value="$i18n.locale === 'ko' ? visitorItem.OPTION_NAME : visitorItem.OPTION_NAME_ENG" :label="$t('eventinvit_label4')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-text-field v-model="visitorItem.REGTYPE_NAME" :label="$t('common_userinfo_label18')" disabled></v-text-field>
              </v-row>

              <!-- 행사별 커스텀 기본정보 -->              
              <template v-for="item in infoItem">
                <template v-if="item.USETYPE == 1">
                  <template v-if="item.LANTYPE == 4">
                    <v-row dense :key="item.INPUT_CODE">
                      <label style="color:rgba(0,0,0,0.38)">{{item.NAME}}</label>
                    </v-row>
                    <template v-if="visitorItem['INFO'+item.INPUT_CODE] != null && visitorItem['INFO'+item.INPUT_CODE] != undefined && visitorItem['INFO'+item.INPUT_CODE].length > 1">
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <img  :height="item.HEIGHT" :width="item.WIDTH" :src="visitorItem['INFO'+item.INPUT_CODE]" class="image"/>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <label style="color:rgba(0,0,0,0.38)">{{$t('common_userinfo_label5')}}</label>
                      </v-row>
                    </template>
                  </template>
                  <template v-else-if="item.LANTYPE == 5">
                    <v-row dense :key="item.INPUT_CODE">
                      <label style="color:rgba(0,0,0,0.38)">{{item.NAME}}</label>
                    </v-row>
                    <template v-if="visitorItem['INFO'+item.INPUT_CODE] != null && visitorItem['INFO'+item.INPUT_CODE] != undefined && visitorItem['INFO'+item.INPUT_CODE].length > 1">
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <a :href="visitorItem['INFO'+item.INPUT_CODE]" download target="_blink">File Download</a>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <label style="color:rgba(0,0,0,0.38)">{{$t('common_userinfo_label19')}}</label>
                      </v-row>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="item.MAXLINES == 1">
                      <v-row dense  :key="item.INPUT_CODE">
                        <v-textarea dense no-resize outlined height="70"
                        v-if="item.USETYPE == 1" v-model="visitorItem['INFO'+item.INPUT_CODE]" :label="item.NAME" disabled></v-textarea>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense  :key="item.INPUT_CODE">
                        <v-text-field v-if="item.USETYPE == 1" v-model="visitorItem['INFO'+item.INPUT_CODE]" :label="item.NAME" disabled></v-text-field>
                      </v-row>
                    </template>
                  </template>
                </template>
              </template>

              <v-row dense v-if="useInfo.USETEL == 1">
                  <v-text-field v-model="visitorItem.TEL" :label="$t('common_userinfo_label6')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USEMAIL == 1">
                  <v-text-field v-model="visitorItem.EMAIL" :label="$t('common_userinfo_label7')" disabled></v-text-field>
              </v-row>

              <v-row dense v-if="useInfo.USEPW == 1">
                  <v-text-field v-model="visitorItem.PRINT_NUMBER" :label="$t('common_userinfo_label8')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USESEX == 1">
                  <v-text-field v-model="visitorItem.SEX_NAME" :label="$t('common_userinfo_label9')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USEYEAR == 1">
                  <v-text-field v-model="visitorItem.YEAR" :label="$t('common_userinfo_label10')" counter="4" :suffix="$t('common_userinfo_label13')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USENATION == 1">
                  <v-text-field v-model="visitorItem.NAMEKOR" :label="$t('common_userinfo_label12')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="visitorItem.STATE_NAME" :label="$t('common_userinfo_label13')" disabled></v-text-field>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_user = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>    


    <v-row dense align="center" justify="end" no-gutters>
      <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      <v-spacer/>
      <template v-if="grade == 99">
        <v-col  cols="12" offset-md="1" md="3" sm="12" xs="12">
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <template v-if="grade == 99">
        <v-col cols="12" md="3" sm="12" xs="12">
          <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
        </v-col>
      </template>
      <template v-else>
        <v-col cols="12" offset-md="4" md="3" sm="12" xs="12">
          <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
        </v-col>
      </template>
      <v-col cols="2" class="pl-1">
        <v-select dense v-model="SEARCH_STATE" :items="SEARCH_STATELIST" :label="$t('common_userinfo_label13')" 
        :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" outlined hide-details  @change="search_run"
          />
      </v-col>
    </v-row>

    <v-row align="center" dense>
      <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
      <v-spacer/>
      <v-col cols="6" md="2" sm="6" xs="6" class="pa-0">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details
          />
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>      
      <v-col cols="6" md="1" sm="6" xs="6" align="center" class="pa-0">
        <v-btn style="width:94%" color="#4e6ef7" large rounded  @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn>
      </v-col>
    </v-row>

  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        height="600px"
        fixed-header
        >

        <template v-slot:header.IDX>
          <a :class="sort_name=='IDX'?'cheader_sortselect':'cheader_sort'" @click="customsort('IDX')">{{$t('eul_col2')}}</a>
        </template>
        <template v-slot:header.SORT>
          <a :class="sort_name=='SORT'?'cheader_sortselect':'cheader_sort'" @click="customsort('SORT')">{{$t('eul_col1')}}</a>
        </template>
        <template v-slot:header.INFO1>
          <a :class="sort_name=='INFO1'?'cheader_sortselect':'cheader_sort'" @click="customsort('INFO1')">{{$t('eul_col7')}}</a>
        </template>
        <template v-slot:header.STATE_NAME>
          <a :class="sort_name=='STATE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('STATE_NAME')">{{$t('eul_col5')}}</a>
        </template>
        <template v-slot:header.TEL>
          <a :class="sort_name=='TEL'?'cheader_sortselect':'cheader_sort'" @click="customsort('TEL')">{{$t('eul_col8')}}</a>
        </template>
        <template v-slot:header.EMAIL>
          <a :class="sort_name=='EMAIL'?'cheader_sortselect':'cheader_sort'" @click="customsort('EMAIL')">{{$t('eul_col15')}}</a>
        </template>

        <template v-for="cname in header_names" v-slot:[`header.${cname}`]>
          <a :key="cname" :class="sort_name == cname ? 'cheader_sortselect':'cheader_sort'" @click="customsort(`${cname}`)">{{ cname }}</a>
        </template>

        <!-- 
        <template v-slot:item.NAME="{ item }">  
          <a @click="loadvisitor(item.VISITOR_IDX, item.EVENT_IDX)" >{{item.NAME}}</a>
        </template>
        -->
        <!-- 
        <template v-slot:item.delete="{item}">
          <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>
        -->

      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" style="font-size:16px" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn style="font-size:16px" color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn class="font-size:16px" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" style="font-size:16px" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  </v-container>
</template>
<script>


import XLSX from 'xlsx'
export default {

  beforeDestroy(){

  },

  mounted(){

    if(this.$session.get("GRADE") < 10){
      this.$alert(this.$t("common_nograde"));
      this.$router.push("Login");
      return;
    }

    this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
    this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
    this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
    this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
    this.grade = this.$session.get("GRADE");
    
    /*
    if(this.grade > 90){
      this.headers.push({text: '삭제', value: 'delete', sortable: false, align:'center' });
    }
    */


    if(this.$session.exists("ADMIN_IDX")){
      this.initpage();
    }else{
      //키값 없으면 로그인으로
      this.$router.push("Login");
    }
  },

  data: () => ({
    useInfo:{},
    //필수 페이징 파라메터
    totalcnt : 0,       //전체 아이템 개수
    
    page : 0,
    maxpage : 0,        //전체 페이지 개수
    startpage : 1,      //시작 인덱스
    bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
    subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
    loading : false,    //로딩 표시

    //테이블 정의
    headers: [
      {text: '등록번호', value: 'IDX', width:"120", sortable: false, align:'center' },
      {text: '순서',     value: 'SORT', width:"120", sortable: false, align:'center' },
      {text: '이름',     value: 'INFO1', width:"120", sortable: false, align:'center' },
      {text: '연락처',   value: 'TEL', width:"120", sortable: false, align:'center' },
      {text: '이메일',   value: 'EMAIL', width:"100", sortable: false, align:'center'},
      {text: '상태',     value: 'STATE_NAME', width:"100", sortable: false, align:'center'},
    ],
    itemList: [],
    header_names:[],

    sort_name: 'IDX',
    sort_type: true,    //true : DESC, false: ASC

    search_keyword : '',
    search: '',         //필터링용 검색어

    //한 페이지 ROW 개수 설정
    pagerow : 20,       //한 페이지에 보여줄 row수
    pagerow_combo : [
        {NAME:'20', VALUE:20}
      , {NAME:'50', VALUE:50}
      , {NAME:'100', VALUE:100}
      , {NAME:'200', VALUE:200}
    ],    

    SEARCH_STATE: -1,
    SEARCH_STATELIST: [
        {name:'전체', name2:"All",      value:-1}
      , {name:'접수', name2:"Register", value:1}
      , {name:'결제', name2:"Payment",  value:2}
      , {name:'출력', name2:"Print",    value:3}
      , {name:'관람', name2:"Watch",    value:4}
      , {name:'취소', name2:"Cancel",   value:5}
      , {name:'환불', name2:"Refund",   value:6}
    ],

    list:[],

    SEARCH_COM_IDX: null,
    SEARCH_COM_NAME: '',
    SEARCH_EVENT_IDX: null,
    SEARCH_EVENT_NAME: '',
    grade : 0,

    dialog_user:false,    
    visitorItem: {},
    infoItem:[],    //행사별 기본접수양식 커스텀 정보 

  }),

  methods: {


    insertAt(array, index, item) {
      array.splice(index, 0, item);
    },

    startDownload(){

        this.$confirm(this.$t('common_search_downexcel')).then(() => {

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }
          
          this.loading = true;
          this.$http.post(this.$host+'/api/EventUserFormatListExcel',{
              search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
            , sort_name:this.sort_name
            , sort_type: this.sort_type==true ? "DESC" : "ASC" 
            , ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , SEARCH_STATE: this.SEARCH_STATE
            , EVENT_IDX: this.SEARCH_EVENT_IDX
            , COM_IDX: this.SEARCH_COM_IDX
            , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                
                const list = result.data.resultData;
                var item_sheet = XLSX.utils.json_to_sheet(list);

                //컬럼별 너비
                var wscols = [{wch:20},{wch:30},{wch:20},{wch:10},{wch:10},{wch:10},{wch:20,},{wch:20},{wch:15},{wch:15},{wch:10},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15},{wch:15}];
                item_sheet['!cols'] = wscols;

                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('vcomout_msg4'));
                XLSX.writeFile(wb, this.$t('vcomout_msg5')+Date.now().toString()+'.xlsx');


            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

        });
    },

    initpage(){
      this.getInfoItemList();
      //첫페이지 로드
      this.loadpage(1);
    },

    loadpage(p){
      if(this.SEARCH_COM_IDX == null){
        this.$alert(this.$t('common_select_tcom'));
        return;
      }
      if(this.SEARCH_EVENT_IDX == null){
        this.$alert(this.$t('common_select_tevent'));
        return;
      }
      
      this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      this.loading = true;
      this.page = p;

      this.$http.post(this.$host+'/api/EventUserFormatList',{
            search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
          , sort_name:this.sort_name
          , sort_type: this.sort_type==true ? "DESC" : "ASC" 
          , page: this.page
          , pagerow: this.pagerow
          , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , SEARCH_STATE: this.SEARCH_STATE
          , EVENT_IDX: this.SEARCH_EVENT_IDX
          , COM_IDX: this.SEARCH_COM_IDX
          , LAN_CODE:this.$i18n.locale
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
        
        if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.totalcnt = result.data.totalcnt;
            this.makepaging();
            const list = result.data.resultData;

            if(this.page == 1 && list.length > 0){
              //헤더 셋팅
              this.headers.splice(0, this.headers.length);   
              this.headers.push({text: '등록번호', value: 'IDX', width:"120", sortable: false, align:'center' });
              this.headers.push({text: '순서',     value: 'SORT', width:"120", sortable: false, align:'center' });
              this.headers.push({text: '이름',     value: 'INFO1', width:"120", sortable: false, align:'center' });
              this.headers.push({text: '연락처',   value: 'TEL', width:"120", sortable: false, align:'center' });
              this.headers.push({text: '이메일',   value: 'EMAIL', width:"100", sortable: false, align:'center'});
              this.headers.push({text: '상태',     value: 'STATE_NAME', width:"100", sortable: false, align:'center'});

              this.header_names.splice(0, this.header_names.length);   
              result.data.resultNames.forEach(element => {
                this.headers.push({text: element, value: element, width:"200", sortable: false, align:'center' }); 
                this.header_names.push(element);
              });
            }

            list.forEach(element => {
                this.itemList.push(element); 
            });

            this.loading = false;

        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.loading = false;
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }else{
          this.loading = false;
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        this.loading = false;
        if(error.message == 'Request failed with status code 429')
        {
          this.$alert(this.$t("common_reqer"));
        }else{
          this.$alert(error.message);
        }
      });

    },    



      //아이템 삭제
      delete_item(item){
        
        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/VisitorComoutDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

    search_run(){

      this.loadpage(1);

    },

    loadvisitor(vidx, eidx){

        this.$http.post(this.$host+'/api/VisitorDetail',{
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , EVENT_IDX: eidx
            , VISITOR_IDX: vidx
            , LAN_CODE:this.$i18n.locale
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              this.visitorItem = list[0];
              this.dialog_user = true;

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          
        });

    },          

    //행사별 기본접수양식 가져오기
    getInfoItemList(){
      
      this.infoItem.splice(0, this.infoItem.length);   //데이터 초기화
      
      if(this.SEARCH_COM_IDX == null){
          return;
      }
      if(this.SEARCH_EVENT_IDX == null){
        return;
      }

      this.$http.post(this.$host+'/api/InputEventList',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX:   this.SEARCH_COM_IDX
          , EVENT_IDX: this.SEARCH_EVENT_IDX
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
        if(result.data.resultCode == 0){
            
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            this.useInfo = result.data.useData;
            const list = result.data.resultData;
            list.forEach(element => {
                this.infoItem.push(element); 
            });
        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.loading = false;
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        this.loading = false;
        if(error.message == 'Request failed with status code 429')
        {
          this.$alert(this.$t("common_reqer"));
        }else{
          this.$alert(error.message);
        }
      });
    },    

    customsort(sortname){
      this.sort_name = sortname;
      this.sort_type = !this.sort_type;
      this.loadpage(this.page);
    },

    //일차별 정렬은 널값을 뒤로 밀어야 한다.
    customsortday(sortname){
      this.sort_name = `(${sortname} IS NULL) ASC, ${sortname}`;
      this.sort_type = !this.sort_type;
      this.loadpage(this.page);
    },

    prev(){
        this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
        this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
        this.loadpage(temp_page);
    },
    next(){
        this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
        this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        var temp_page = this.bottompage;
        this.loadpage(temp_page);
    },

    makepaging(){
      var div1 = this.totalcnt / this.pagerow; 
      var div2 = this.totalcnt % this.pagerow;
      if(div2 == 0){  
          this.maxpage = parseInt(div1);    
      }else{
          this.maxpage = parseInt(div1+1);
      }
      if(this.bottompage == 1){
        this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
      }
    },



    //검색조건 업체 설정
    eventsearchcb(val1){
      
      if(val1.NAME.length > 0){
        this.SEARCH_EVENT_NAME = val1.NAME;
        this.SEARCH_EVENT_IDX  = val1.IDX;
        this.$session.set("EVENT_IDX", val1.IDX);
        this.$session.set("EVENT_NAME",val1.NAME);
        
        //infoItem 가져오기
        this.getInfoItemList();

      }else{
        this.SEARCH_EVENT_NAME = "";
        this.SEARCH_EVENT_IDX  = null;
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.$session.set("EVENT_START", null);
        this.$session.set("EVENT_END", null);
      }
      this.search_run();
    },

    // eslint-disable-next-line no-unused-vars
    comsearchclear(var2){
        this.SEARCH_COM_IDX    = null;
        this.SEARCH_COM_NAME   = '';
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.search_run();
    },

    //업체선택 콜백
    comdialogcb(val){
      if(val.NAME.length > 0){
        this.editedItem.COM_NAME = val.NAME;
        this.editedItem.COM_IDX  = val.IDX;
      }else{
        this.$alert(this.$t('common_select_company'));
        return;
      }
    },

    //검색조건 업체 설정
    comsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_COM_NAME = val1.NAME;
        this.SEARCH_COM_IDX  = val1.IDX;
        this.$session.set("COM_IDX", val1.IDX);
        this.$session.set("COM_NAME", val1.NAME);
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }else{
        this.SEARCH_COM_NAME = '';
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }
      this.search_run();
    },



  }
    
}

</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>